module.exports = __webpack_public_path__ + "static/media/ic-compliance-monitor-active.5b7a13e6.svg";